export default __webpack_public_path__ + "static/media/DE1.5adc3ec4.svg";